export default "__VITE_ASSET__DAkgQeo1__"